import { render, staticRenderFns } from "./AppQuestionnaire.vue?vue&type=template&id=7008ffd5&scoped=true"
import script from "./AppQuestionnaire.vue?vue&type=script&lang=ts"
export * from "./AppQuestionnaire.vue?vue&type=script&lang=ts"
import style0 from "./AppQuestionnaire.vue?vue&type=style&index=0&id=7008ffd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7008ffd5",
  null
  
)

export default component.exports